var exports = {
  "vK": "ChannelFollowModal.module__banner___UGVxLU",
  "Wp": "ChannelFollowModal.module__patternImage___UGVxLU",
  "JE": "ChannelFollowModal.module__bannerRow___UGVxLU",
  "QE": "ChannelFollowModal.module__sourceGuildIcon___UGVxLU",
  "AQ": "ChannelFollowModal.module__sourceChip___UGVxLU",
  "fS": "ChannelFollowModal.module__sourceChipIcon___UGVxLU",
  "jl": "ChannelFollowModal.module__sourceChipName___UGVxLU",
  "Qs": "ChannelFollowModal.module__content___UGVxLU",
  "Lv": "ChannelFollowModal.module__intro___UGVxLU",
  "DD": "ChannelFollowModal.module__title___UGVxLU",
  "h_": "ChannelFollowModal.module__description___UGVxLU",
  "aK": "ChannelFollowModal.module__hint___UGVxLU",
  "p$": "ChannelFollowModal.module__emptyState___UGVxLU",
  "By": "ChannelFollowModal.module__guildOption___UGVxLU",
  "XN": "ChannelFollowModal.module__guildAvatar___UGVxLU",
  "oM": "ChannelFollowModal.module__guildAvatarPlaceholder___UGVxLU",
  "ed": "ChannelFollowModal.module__optionLabel___UGVxLU",
  "TN": "ChannelFollowModal.module__channelOption___UGVxLU",
  "p": "ChannelFollowModal.module__channelIcon___UGVxLU",
  "yb": "ChannelFollowModal.module__categoryName___UGVxLU",
};

module.exports = exports;
